export const mixin = {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("user")) ?? "", //本地存储对象
      Height: document.documentElement.clientHeight - 260 + "px", //用来给table设默认高度
    };
  },
  methods: {

  },
};
